import { render } from "./ListLoader.vue?vue&type=template&id=54cfcc72&scoped=true"
import script from "./ListLoader.vue?vue&type=script&lang=js"
export * from "./ListLoader.vue?vue&type=script&lang=js"

import "./ListLoader.vue?vue&type=style&index=0&id=54cfcc72&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cfcc72"]])

export default __exports__